import i18n from 'i18n'
import ContentLoader, { IContentLoaderProps } from 'react-content-loader'
import { theme } from 'theme'

interface StorageProgressLoaderProps extends IContentLoaderProps {
  variant: 'counter' | 'bar'
}

const StorageProgressLoader = (props: StorageProgressLoaderProps) => {
  const { variant, ...rest } = props

  if (variant === 'counter') {
    return (
      <ContentLoader
        height={10}
        width={72}
        viewBox="0 0 72 10"
        backgroundColor={theme.palette.surface.subtle}
        foregroundColor={theme.palette.border.primary}
        style={{
          display: 'block',
          marginRight: i18n.dir() === 'rtl' ? undefined : '16px',
          marginLeft: i18n.dir() === 'rtl' ? '16px' : undefined,
          transform: i18n.dir() === 'rtl' ? 'scaleX(-1)' : undefined
        }}
        {...rest}
      >
        <rect x="0" y="0" rx="3" ry="3" width="72" height="10" />
      </ContentLoader>
    )
  }

  return (
    <ContentLoader
      height={6}
      width={'100%'}
      viewBox="0 0 240 6"
      preserveAspectRatio="none"
      backgroundColor={theme.palette.surface.subtle}
      foregroundColor={theme.palette.border.primary}
      style={{
        display: 'block',
        transform: i18n.dir() === 'rtl' ? 'scaleX(-1)' : undefined
      }}
      {...rest}
    >
      <rect x="0" y="0" rx="3" ry="3" width="240" height="6" />
    </ContentLoader>
  )
}

export default StorageProgressLoader
